// extracted by mini-css-extract-plugin
module.exports = {"gettingNumber__number":"CellNumberPage_gettingNumber__number__2iyPH","gettingNumber__title":"CellNumberPage_gettingNumber__title__147WF"};